import { APP_ROUTES } from "../constants";

export const FocusedMarketUtil = {
  buildFocusedMarketDetailPath
};

function buildFocusedMarketDetailPath(code: string): string {
  return code ? APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.DETAIL.replace(":marketCode", code) : APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.BASE;
}